<template>
  <div v-if="sample_collection">
    <template v-if="sample_collection.models.length">
      <b-table
        :items="sample_collection.models"
        :fields="table.fields"
        v-sortable="table.sorts"
        :per-page="table.per_page"
        :current-page="table.current_page"
        id="schedule-cohort-table"
        responsive
      >
        <template #cell(sample_pid)="data">
          <router-link v-if="data.item" :to="`/samples/${data.item.id}`">
            <b>{{ data.item.publicNumber() }}</b>
          </router-link>
        </template>
        <template #cell(receiving_id)="data">
          <template v-if="data.item.receiving_id">
            {{ data.item.receiving_id }}
          </template>
          <template v-else>
            <a class="btn btn-secondary disabled px-1 py-0"> Not Received </a>
          </template>
        </template>
        <template #cell(submission_pid)="data">
          <existence-gate
            :entity="data.item"
            :levels="['submission']"
            :field="'name'"
          >
            <template #existing-content>
              <router-link
                :to="`/samples/${data.item.id}`"
              >
                {{
                  data.item.submission.pid
                }}
              </router-link>
            </template>
          </existence-gate>
        </template>
        <template #cell(customer)="data">
          <existence-gate
            :entity="data.item"
            :levels="table_data.customer"
            :field="'name'"
          >
            <template #existing-content>
              <router-link
                :to="`/customer/${getData(data.item, {
                  levels: table_data.customer,
                  field: 'id',
                })}`"
              >
                {{
                  getData(data.item, {
                    levels: table_data.customer,
                    field: "full_name",
                  })
                }}
              </router-link>
            </template>
          </existence-gate>
        </template>
        <template #cell(identifier)="data">
          {{ data.item.identifier }}
        </template>
        <template #cell(created_at)="data">
          {{ data.item.created_at | moment("L") }}
        </template>
        <template #cell(received)="data">
          <i v-if="hasStatus(data.item, 'Received')" class="fal fa-check" />
        </template>
        <template #cell(prepped)="data">
          <i v-if="data.prepped_at" class="fal fa-check" />
        </template>
        <template #cell(tested)="data">
          <i v-if="data.tested_at" class="fal fa-check" />
        </template>
      </b-table>
      <custom-table-pagination
        :options="table.per_page_options"
        :current_page="table.current_page"
        :per_page="table.per_page"
        :total_rows="sample_collection.models.length"
        @update="updatePaginationData"
        table_id="schedule-cohort-table"
        selector_prefix="Samples per page"
      />
    </template>

    <div v-else>
      <b-alert show class="mb-4">Schedule sample cohort is empty.</b-alert>
    </div>
  </div>
</template>

<script>
import sortable from "@/components/shared/directives/Sortable";
import SampleCollection from "@/collections/lab/SampleCollection";
import CustomTablePagination from "@/components/shared/CustomTablePagination";
import ExistenceGate from "@/components/shared/ExistenceGate";
import { getEntityData, generatePid } from "@/shared/utils";

export default {
  name: "ScheduleCohortTable",
  components: { CustomTablePagination, ExistenceGate },
  directives: { sortable },
  props: {
    sample_collection: {
      type: SampleCollection,
      default: () => null,
    },
  },
  data() {
    return {
      table: {
        fields: [
          { key: "sample_pid", label: "#" },
          { key: "receiving_id", label: "RFID" },
          { key: "submission_pid", label: "Submission" },
          { key: "customer", label: "Customer" },
          { key: "identifier", label: "ID" },
          { key: "number", label: "Num." },
          { key: "created_at", label: "Submitted" },
          { key: "received", label: "Rec'd" },
          { key: "prepped", label: "Prepped" },
          { key: "tested", label: "Tested" },
        ],
        current_page: 1,
        per_page: 10,
        per_page_options: [10, 25, 50],
        sorts: null,
      },
      table_data: {
        customer: ["submission", "project", "customer"],
      },
    };
  },
  methods: {
    generatePid({ entity, prefix }) {
      return generatePid({ entity, prefix });
    },
    getData(entity, data) {
      return getEntityData({
        entity,
        ...data,
      });
    },
    getSubmissionPid(sample) {
      const submission = sample.getSubmission();

      return submission.pid && submission.publicNumber();
    },
    getCustomerData(sample, data) {
      const submission = sample.getSubmission();

      return submission.id && submission.getProject().getCustomer()[data];
    },
    updatePaginationData({ field, value }) {
      this.table[field] = value;
    },
    hasStatus(sample, name) {
      let result = false;
      sample.getSampleStatusLogs().models.forEach((log) => {
        let status = log.getSampleStatus();

        if (status && status.status && status.status === name) {
          result = true;
        }
      });

      return result;
    },
  },
};
</script>
